// API impérative pour remplacer window.alert()/window.confirm() par des
// boites de dialogue stylées Quick Learning (voir components/DialogProvider.js,
// monté une seule fois à la racine de l'app dans index.js). Utilisable
// depuis n'importe quel composant/fichier, sans hook, comme window.alert
// lui-même.

let _showAlert = null;
let _showConfirm = null;

// Appelé par DialogProvider au montage — ne pas utiliser directement ailleurs.
export function _registerDialogHandlers(showAlert, showConfirm) {
  _showAlert = showAlert;
  _showConfirm = showConfirm;
}

/**
 * qlAlert(message, type) — remplace window.alert(message).
 * type: 'warning' | 'error' (rouge), 'info' (bleu), 'success' (vert). Défaut 'warning'.
 */
export function qlAlert(message, type = "warning") {
  if (_showAlert) {
    _showAlert(message, type);
  } else {
    // Filet de sécurité si le DialogProvider n'est pas encore monté.
    window.alert(message);
  }
}

/**
 * qlConfirm(message, onConfirm, opts) — remplace
 * `if (!window.confirm(message)) return; suite();` par
 * `qlConfirm(message, () => { suite(); });`
 * onConfirm n'est appelé QUE si l'utilisateur clique sur le bouton de
 * confirmation (jamais en cas d'Annuler/fermeture).
 * opts: { title, okLabel, danger }
 */
export function qlConfirm(message, onConfirm, opts = {}) {
  if (_showConfirm) {
    _showConfirm(message, onConfirm, opts);
  } else if (window.confirm(message)) {
    onConfirm();
  }
}
